import React from "react";
import { X } from "lucide-react";
import { getPasswordChecklist } from "@/utils/passwordPolicy";

/**
 * Live checklist of password requirements. Only shows requirements still
 * unmet, so the list shrinks as the user types and disappears once satisfied.
 */
export const PasswordRequirements: React.FC<{ password: string; className?: string }> = ({
  password,
  className = "",
}) => {
  if (!password) return null;
  const unmet = getPasswordChecklist(password).filter((item) => !item.met);
  if (unmet.length === 0) return null;
  return (
    <ul className={`mt-2 space-y-1 text-xs ${className}`} aria-label="Password requirements">
      {unmet.map((item) => (
        <li key={item.label} className="flex items-center gap-1.5 text-muted-foreground">
          <X className="h-3.5 w-3.5 shrink-0 opacity-50" aria-hidden />
          <span>{item.label}</span>
        </li>
      ))}
    </ul>
  );
};

export default PasswordRequirements;
